import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const PackageManagementLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to={
          withUpsellingRedirect
            ? '/dashboard/upselling/packageManagement'
            : '/dashboard/building-dashboard/packages'
        }
      >
        <span>
          {t('navbar:upsellingLinks.packages')}
          <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} locked={withUpsellingRedirect} />
        </span>
      </NavLink>
    </div>
  )
}

PackageManagementLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default PackageManagementLink
